import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrderShopifyDTO } from '../../../../../shared/order-shopify-dto';

@Component({
  selector: 'pv-email-auth-shopify',
  templateUrl: './email-auth-shopify.component.html',
  styleUrls: ['./email-auth-shopify.component.scss']
})
export class EmailAuthShopifyComponent implements OnInit {
  @Input() order: OrderShopifyDTO;
  @Output() success: EventEmitter<void> = new EventEmitter<void>();
  email: string = '';
  message: string = '';

  constructor() { }

  ngOnInit() {
  }

  authorizeEmail() {
    console.log('SHOPIFY GOING');
    console.log(this.email);
    console.log(JSON.stringify(this.order));
    if (this.email.toLowerCase() == this.order.email.toLowerCase()) {
      this.success.emit();
    } else {
      console.log('new message')
      this.message = 'Incorrect Email Address, Please Try Again'
    }
  }

}
